import { render, staticRenderFns } from "./Interstitial.vue?vue&type=template&id=40e4b6b8&scoped=true&"
import script from "./Interstitial.vue?vue&type=script&lang=js&"
export * from "./Interstitial.vue?vue&type=script&lang=js&"
import style0 from "./Interstitial.vue?vue&type=style&index=0&id=40e4b6b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e4b6b8",
  null
  
)

export default component.exports